import { render, staticRenderFns } from "./HandoverObject.vue?vue&type=template&id=e476532e&scoped=true"
import script from "./HandoverObject.vue?vue&type=script&lang=js"
export * from "./HandoverObject.vue?vue&type=script&lang=js"
import style0 from "./HandoverObject.vue?vue&type=style&index=0&id=e476532e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e476532e",
  null
  
)

export default component.exports